import { OrderSourceType, OrderStatus } from "@mimber/schema"

export const SOURCE_LABELS: Record<OrderSourceType, string> = {
  [OrderSourceType.EVENT]: "Event",
  [OrderSourceType.STORE_PURCHASE]: "Store Purchase",
  [OrderSourceType.DONATION]: "Donation",
}

export const STATUS_COLORS: Record<OrderStatus, string> = {
  [OrderStatus.PENDING]: "blue",
  [OrderStatus.PAID]: "green",
  [OrderStatus.EXPIRED]: "red",
  [OrderStatus.VOID]: "default",
}
